import { isNotUndefined } from 'typesafe-utils';

export const omitUndefined = <T extends Record<string, any>>(object?: T) =>
  Object.fromEntries(Object.entries(object ?? {}).filter(([_, value]) => isNotUndefined(value)));
